import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaTags = props => {
    return (
        <Helmet 
        >
            <title>{props.title || "드림산업안전센터(주)"}</title>
            <meta name="title" content={props.metatitle || "드림산업안전센터(주)-안전관리 컨설팅"}/>
            <meta name="keywords" content="안전관리업무위탁, 안전관리, 컨설팅, 천안, 아산, 위험성평가, iso45001, kosha, 안전관리기술지도, 공정안전보고서, 자율안전확인신고, 근골격계유해요인조사, 유해위험방지계획서, 안전관리대행, 드림산업안전센터"  />
            <meta name="description" content={props.description || "안전관리업무위탁 등 안전관련 컨설팅 전문 업체 입니다."}/>

            <meta property="og:title" content={props.ogtitle || "드림산업안전센터(주)"}/>
            <meta property="og:description" content={props.ogdescription || "안전관련 건설팅 전문 업체"}/>
            <meta property="og:url" content={props.ogurl || "http://dreamisc.co.kr"}/>
            <meta property="og:site-name" content="드림산업안전센터(주)" />
            <meta property="og:image:height" content="800" />
            <meta property="og:image:width" content="800" />
            <meta property="og:url" content="http://dreamisc.co.kr"/>
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="ko_KR" />

            {props.children}
        </Helmet>
    )
}

export default MetaTags;
